export default {
  colors: {
    general: {
      primary: "#ff1177",
      secondary: "#fa8072",
      card: "#FFFFFF"
    },
    brands: {
      facebookBlue: "#4267b2"
    },
    border: {
      primary: "#eeeeee",
      secondary: "#72bbfa",
      faded: "#ffffff15"
    },
    section: {
      primary: "#FFFFFF",
      secondary: "#72bbfa",
      tertiary: "#fb5373",
      quarternary: "#d322ff"
    },
    text: {
      contrast: "#FFFFFF",
      "primary.lightest": "#DDDDDD",
      "primary.light": "#AAAAAA",
      "primary.main": "#777777",
      "primary.dark": "#222222",
      primary: {
        lightest: "#DDDDDD",
        light: "#AAAAAA",
        main: "#777777",
        dark: "#222222"
      },
      secondary: "#72bbfa",
      tertiary: "#fa8072",
      error: "#fa8072",
      login: "#ffffff",
      white: "#ffffff"
    },
    button: {
      primary: "#FFFFFF",
      secondary: "#72bbfa",
      tertiary: "#fb5373",
      quarternary: "#d322ff",
      login: "#4267b2"
    },
    bg: {
      top: "#ff1177",
      bottom: "#fa8072"
    }
  },
  screenSizes: {
    tiny: "300px",
    tinyx: "350px",
    small: "400px",
    smallx: "500px",
    medium: "700px",
    mediumx: "1000px",
    large: "1300px",
    largex: "1950px",
    values: {
      tiny: "300",
      tinyx: "350",
      small: "400",
      smallx: "500",
      medium: "700",
      mediumx: "1000",
      large: "1300",
      largex: "1950"
    }
  },
  spacing: {
    tiny: "0.2rem",
    tinyx: "0.3rem",
    small: "0.5rem",
    smallx: "0.7rem",
    medium: "1rem",
    mediumx: "1.5rem",
    large: "2rem",
    largex: "4rem"
  },
  fonts: {
    primary: `'Montserrat', sans-serif`,
    secondary: `'Montserrat', sans-serif`,
    tertiary: `'Roboto', sans-serif`,
    alternative: `'Patua One', cursive`
  },
  fontSizes: {
    tinier: "0.7rem",
    tiny: "0.8rem",
    tinyx: "0.9rem",
    small: "1rem",
    smallx: "1.2rem",
    medium: "1.3rem",
    mediumx: "1.5rem",
    large: "2rem",
    largex: "2.5rem",
    huge: "3.5rem",
    hugex: "5rem",
    input: "16px",
    button: "16px"
  },
  titleSizes: {
    tiny: "0.8rem",
    tinyx: "1rem",
    small: "1.2rem",
    smallx: "1.5rem",
    medium: "1.7rem",
    mediumx: "2rem",
    large: "2.2rem",
    largex: "2.5rem",
    huge: "3rem",
    hugex: "5rem"
  }
};
